export const REST_APPVIZER_PROJECT = "/rest/datocms-plugin";
